import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PageSpinner from '@/components/PageSpinner';
import UnauthenticatedApp from '@/UnauthenticatedApp';
import { ROUTES } from '@/constants/routes';
import { getElectrolyteBaseUrl } from '@/constants/urls';

const JustworksRedirect = () => {
  useEffect(() => {
    window.location.replace(`${getElectrolyteBaseUrl()}?connection=justworks`);
  }, []);

  return null;
};

const TrinetSignup = lazy(() => import('@/pages/Signup/Trinet/TrinetSignup'));
const GenericSignup = lazy(
  () => import('@/pages/Signup/Generic/GenericSignup')
);
const SdkTestPage = lazy(() => import('@/pages/SdkTest/SdkTestPage'));

const UnauthenticatedRoutes = () => {
  const flags = useFlags();
  const { itHubSdkTestPage } = flags;

  // If feature flags are still loading, show a spinner
  // This is used to prevent the app from evaluating undefined flags as false
  if (!Object.keys(flags).length) {
    return <PageSpinner />;
  }

  return (
    <Routes>
      <Route path="/justworks" element={<JustworksRedirect />} />
      <Route
        path="/trinet"
        element={
          <Suspense fallback={<PageSpinner />}>
            <TrinetSignup />
          </Suspense>
        }
      />
      <Route
        path="/signup"
        element={
          <Suspense fallback={<PageSpinner />}>
            <GenericSignup />
          </Suspense>
        }
      />
      {itHubSdkTestPage && (
        <Route
          path={ROUTES.SDK_TEST}
          element={
            <Suspense fallback={<PageSpinner />}>
              <SdkTestPage />
            </Suspense>
          }
        />
      )}
      {/* All other routes go to UnauthenticatedApp which handles the login flow */}
      <Route path="*" element={<UnauthenticatedApp />} />
    </Routes>
  );
};

export default UnauthenticatedRoutes;
